export const allTopics = [
    {
        id:1,
        value:'all topics',
        label:'All Topics'
    },
    {
        id:2,
        value:'algorithms',
        label:'Algorithms'
    },
    {
        id:3,
        value:'database',
        label:'Database'
    },
    {
        id:4,
        value:'shell',
        label:'Shell'
    },
    {
        id:5,
        value:'concurrency',
        label:'Concurrency'
    },{
        id:6,
        value:'javascript',
        label:'Javascript'
    }
]

export const problems = [
    {
        id:1,
        label:'Two Sum',
        name:'two-sum',
        difficulty:'Easy',
        acceptance:62.5
    },
    {
        id:2,
        label:'Reverse String',
        name:'reverse-string',
        difficulty:'Easy',
        acceptance:90.3
    },
    {
        id:3,
        label:'Next Greater Element',
        name:'next-greater-element',
        difficulty:'Medium',
        acceptance:29.4
    },
    {
        id:4,
        label:'Linked List Cycle',
        name:'linked-list-cycle',
        difficulty:'Medium',
        acceptance:58.1
    },
    {
        id:5,
        label:'Missing Number',
        name:'missing-number',
        difficulty:'Easy',
        acceptance:32.3
    },
    {
        id:6,
        label:'Rotate Array',
        name:'rotate-array',
        difficulty:'Medium',
        acceptance:82.7
    },
    {
        id:7,
        label:'Sort an Array',
        name:'sort-an-array',
        difficulty:'Medium',
        acceptance:43.5
    },

]

export const topImages = [
    'https://assets.leetcode.com/users/images/f2d736c1-007d-4b51-a476-a7afc8ef3dac_1727074938.5687914.png',
    'https://assets.leetcode.com/users/images/49479bba-73b3-45d2-9272-99e773d784b2_1687290663.3168745.jpeg',
    'https://assets.leetcode.com/users/images/770789b0-c96b-4663-86d1-baab25534864_1669795265.8012726.png'
  ];

export const coverImages = [
    {
        image :  'https://assets.leetcode.com/study_plan_v2/top-interview-150/cover',
        id: 1,
        header: 'Top Inerview 150',
        description:'Must-do List for Interview Prep'

    },
    {
        image :  'https://assets.leetcode.com/study_plan_v2/leetcode-75/cover',
        id: 2,
        header: 'LeetCode 75', 
        description: 'Ace Coding Interview with 75 Qs'
     
    },
    {
        image: 'https://assets.leetcode.com/study_plan_v2/top-sql-50/cover',
        id: 3,
        header: 'SQL 50', 
        description: 'Creack SQL Interview in 50 Qs'
    },
    {
        image : 'https://assets.leetcode.com/study_plan_v2/introduction-to-pandas/cover',
        id: 4,
        header: 'Introduction to Pandas',
        description: 'Learn Basic Pandas in 15 Qs'
    },
    {
        image : 'https://assets.leetcode.com/study_plan_v2/30-days-of-javascript/cover',
        id: 5,
        header: '30 Days of Javascript',
        description: 'Learn JS Basics with 30 Qs'
    },
    {
        image: 'https://assets.leetcode.com/study_plan_v2/amazon-spring-23-high-frequency/cover',
        id: 6,
        header: "Amazon Spring '23 High Frequency",
        description: 'Practice Amazon 25 Recently...'
    }
]